// On scroll
document.addEventListener("scroll", () => {
  // Change header size on scroll
  const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
  const header = document.getElementById("header");

  if (!header) return;

  scrollPosition > 50 ? header.classList.add("is-scrolled") : header.classList.remove("is-scrolled");
});